import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import { isEmpty, isNil } from 'lodash';
import { useDispatch } from 'react-redux';
import { createJira } from '../../redux/actions/manageAssetActions';

function CreateJiraBtn({ assetId, productId }) {
	const dispatch = useDispatch();
	const handleClick = () => {
		dispatch(createJira({ assetId, productId }));
	};
	// disable Create Jira ticket button, when product is not selected.
	const hasProduct = !(isNil(productId) || isEmpty(productId));
	const titleMsg = hasProduct ? 'Create Jira ticket for Asset' : 'Product not selected';
	return (
		<Tooltip title={titleMsg} arrow={true} placement="top">
			<span>
				<Button
					color="primary"
					size="small"
					onClick={handleClick}
					variant="outlined"
					startIcon={<CreateOutlinedIcon />}
					disabled={!hasProduct}
				>
					Create Jira
				</Button>
			</span>
		</Tooltip>
	);
}

export default CreateJiraBtn;
